import { useQuery } from "@tanstack/react-query";
import { loadOnboardingData } from "../../apis";

export function useOnboardingResult({
  isMobile,
  isDark,
  albumId,
  albumName,
}: {
  isMobile: boolean;
  isDark: boolean;
  /**
   * Address one album directly instead of letting the platform flags pick it.
   * The home slider (id 4) is not reachable through those flags.
   */
  albumId?: number | string;
  /**
   * Address it by CMS name instead — for albums whose id is not known at build
   * time. Wins over `albumId`.
   */
  albumName?: string;
}) {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: [
      "onBoardingResult",
      albumId ?? null,
      albumName ?? null,
      isMobile,
      isDark,
    ],
    queryFn: async () => {
      return loadOnboardingData(isMobile, isDark, albumId, albumName);
    },
  });
  return {
    data,
    error,
    isLoading: isLoading || isFetching,
    refetch,
  };
}
